import { DBDef_FAQ } from '@app/advisor-ui-shared/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ModuleFE_AdvisorStatic } from '../../../ModuleFE_AdvisorStatic.js';
export const dispatch_onFAQsUpdated = new ThunderDispatcherV3('__onFAQsUpdated');
class ModuleFE_Advisor_FAQ_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_FAQ, dispatch_onFAQsUpdated);
    }
}
export const ModuleFE_Advisor_FAQ = new ModuleFE_Advisor_FAQ_Class();
//# sourceMappingURL=module.js.map